<template>
  <div :class="isOpen ? 'is-open' : ''">
    <div
      :class="additionalButtonClasses"
    >
      <!-- eslint-disable vuejs-accessibility/no-static-element-interactions -->
      <h3
        class="accordion__title"
        @click.prevent="toggleItem()"
        @keypress="toggleItem()"
      >
        {{ title }}
      </h3>
    </div>
    <div class="accordion__content">
      <div class="mt-2 mb-5">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'KfAccordionItem',
  props: {
    title: {
      type: String,
      default: '<No title>',
    },
    isInitiallyOpen: {
      type: Boolean,
      default: false,
    },
    additionalButtonClasses: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      isOpen: this.isInitiallyOpen,
    };
  },
  methods: {
    toggleItem() {
      this.isOpen = !this.isOpen;
    },
  },
};
</script>
